import {
  CampaignPlatformTypeEnum,
  CampaignStatusEnum,
  SpotifyCampaign,
  TiktokCampaign,
} from 'src/Types/campaigns'
import { formatDate } from 'src/Constants/formatDate'
import dayjs from 'src/Helpers/dayjs'
import { MetaCampaign } from 'src/Redux/ad-campaignApi'

const getVideosText = (videos?: number): string => {
  const submittedVideo = videos === 1 ? 'video' : 'videos'
  return `${videos ?? 0} ${submittedVideo}`
}
const getReviewsText = (reviews?: number): string => {
  const submittedReview = reviews === 1 ? 'review' : 'reviews'
  return `${reviews ?? 0} ${submittedReview}`
}

const getReviewOrVideoText = (reviews?: number, videos?: number): string => {
  if (typeof reviews === 'number') {
    return getReviewsText(reviews)
  }
  if (typeof videos === 'number') {
    return getVideosText(videos)
  }
  return ''
}

type InitialCampaign = TiktokCampaign | SpotifyCampaign | MetaCampaign
type GetStatusTextParams = Pick<
  InitialCampaign,
  | 'status'
  | 'allReview'
  | 'platformType'
  | 'submittedVideosAmount'
  | 'startDate'
>

const withReviewStatuses = [
  CampaignStatusEnum.RUNNING,
  CampaignStatusEnum.INPROCESS,
  CampaignStatusEnum.ENDED,
  CampaignStatusEnum.STOPPED,
]

export const getStatusText = (params: GetStatusTextParams): string => {
  if (withReviewStatuses.includes(params.status as CampaignStatusEnum)) {
    return getReviewOrVideoText(params.allReview, params.submittedVideosAmount)
  }
  if (
    params.status === CampaignStatusEnum.PENDING_APPROVAL ||
    params.status === CampaignStatusEnum.AWAITING_REVIEW
  ) {
    return 'Take up to 45 min'
  }
  if (
    params.status === CampaignStatusEnum.SCHEDULED &&
    params.platformType === CampaignPlatformTypeEnum.META
  ) {
    return 'Will start within 24h-72h'
  }

  if (params.status === CampaignStatusEnum.SCHEDULED) {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
    const date = dayjs(params.startDate)
      .tz(timezone)
      .format(formatDate.formatDateMonthFull)
    return `Will start on ${date}`
  }

  return ''
}
